import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Modal, TextField } from "@mui/material";
import axios from "axios";
import { url } from "../../../utils/url";

const AdminCars = () => {
  const [carsList, setCarList] = useState([]);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [newCar, setNewCar] = useState({
    regNumber: "",
    brand: "",
    model: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const carsRequest = await axios.get(`${url}vehicles?isActive=true`, { withCredentials: true });
        setCarList(carsRequest.data);
      } catch (err) {
        console.log(err);
        setError("Възникна проблем! Моля опитайте по-късно");
      }
    })();
  }, []);

  const addCarHandler = async () => {
    try {
      setError(null);
      await axios.post(
        `${url}vehicles`,
        {
          regNumber: newCar.regNumber,
          brand: newCar.brand,
          model: newCar.model,
          isActive: true,
        },
        { withCredentials: true }
      );
      const request = await axios.get(`${url}vehicles?isActive=true`, { withCredentials: true });
      setCarList(request.data);
    } catch (err) {
      console.log(err);
      setError("Възникна проблем! Моля опитайте по-късно");
      return;
    }

    setNewCar({
      regNumber: "",
      brand: "",
      model: "",
    });
    setOpen(false);
  };

  const removeCarHandler = async (car) => {
    setError(null);
    const carRemoval = { ...car, isActive: false };
    try {
      await axios.put(`${url}vehicles/${car.id}`, carRemoval, { withCredentials: true });
      const request = await axios.get(`${url}vehicles?isActive=true`, { withCredentials: true });
      setCarList(request.data);
    } catch (err) {
      setError("Възникна проблем! Моля опитайте по-късно");
      return;
    }
  };

  const isButtonEnabled = () => {
    return newCar.regNumber.length >= 4 && newCar.brand.length >= 3 && newCar.model.length >= 2;
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "15px",
        }}
      >
        <Button variant="contained" onClick={() => setOpen(true)}>
          Нова Кола
        </Button>
        {error && (
          <Typography color="red" align="center">
            {error}
          </Typography>
        )}
        <Modal open={open} onClose={() => setOpen(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "85%",
                lg: "400px",
              },
              bgcolor: "background.paper",
              borderRadius: "10px",
              boxShadow: 24,
              padding: "20px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "30px",
            }}
          >
            <Button
              variant="text"
              sx={{
                color: "black",
                alignSelf: "flex-end",
                padding: 0,
                minWidth: "10px",
              }}
              onClick={() => setOpen(false)}
            >
              X
            </Button>
            <Typography variant="h6" component="h2">
              Добавяне на нова кола
            </Typography>
            <TextField label="Регистрационен номер" onChange={(e) => setNewCar({ ...newCar, regNumber: e.target.value })} value={newCar.regNumber} />
            <TextField label="Марка" onChange={(e) => setNewCar({ ...newCar, brand: e.target.value })} value={newCar.brand} />
            <TextField label="Модел" onChange={(e) => setNewCar({ ...newCar, model: e.target.value })} value={newCar.model} />
            {error && (
              <Typography color="red" align="center">
                {error}
              </Typography>
            )}
            <Button variant="contained" onClick={addCarHandler} disabled={!isButtonEnabled()}>
              Добави
            </Button>
          </Box>
        </Modal>
        {carsList.map((car) => (
          <Box
            sx={{
              border: "1px solid black",
              borderRadius: "10px",
              width: {
                xs: "80%",
                lg: "30%",
              },
              padding: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            key={car.id}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography>{car.regNumber}</Typography>
              <Typography>
                {car.brand} {car.model}
              </Typography>
            </Box>
            <Button color="error" onClick={() => removeCarHandler(car)}>
              X
            </Button>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AdminCars;
